import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemoryMonitorService implements OnDestroy {
  private liveSubscription: Subscription | null = null;

  constructor() {}

  /**
   * Imprime el uso actual de memoria en la consola
   */
  logMemoryUsage(): void {
    if ((performance as any).memory) {
      const memory = (performance as any).memory;
      //  console.log('JS Heap Size Limit:', (memory.jsHeapSizeLimit / 1024 / 1024).toFixed(2), 'MB');
      //  console.log('Total JS Heap Size:', (memory.totalJSHeapSize / 1024 / 1024).toFixed(2), 'MB');
      //  console.log('Used JS Heap Size:', (memory.usedJSHeapSize / 1024 / 1024).toFixed(2), 'MB');
    } else {
      // console.warn('performance.memory no está disponible en este navegador.');
    }
  }

  /**
   * Inicia el monitoreo en vivo, imprime memoria cada [ms] milisegundos
   */
  startLiveMonitoring(intervalMs: number = 2000): void {
    // console.log('[MEM] startLiveMonitoring llamado con', intervalMs, 'ms');
    this.stopLiveMonitoring(); // evita múltiples intervalos activos
    this.liveSubscription = interval(intervalMs).subscribe(() => this.logMemoryUsage());
  }

  /**
   * Detiene el monitoreo en vivo
   */
  stopLiveMonitoring(): void {
    if (this.liveSubscription) {
      this.liveSubscription.unsubscribe();
      this.liveSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.stopLiveMonitoring();
  }
}
